module.exports = __webpack_public_path__ + "assets/fonts/icomoon.eot?949e5bcb0fafec40896737ce8d32da40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.eot?i1bfht
// module id = 312
// module chunks = 0